/**
 * Checks if a user is an administrator
 * @param {Object} user - The user object
 * @returns {boolean} - True if user is an admin, false otherwise
 */
export const isAdmin = (user) => {
  return user?.role === "admin";
};

